import Navbar from "@/components/landing/Navbar";
import ChiappellaHero from "@/components/landing/ChiappellaHero";
import Challenge from "@/components/landing/Challenge";
import ChiappellaVision from "@/components/landing/ChiappellaVision";
import GastonFrentes from "@/components/landing/GastonFrentes";
import GastonCredibilidad from "@/components/landing/GastonCredibilidad";
import GastonComoTrabajamos from "@/components/landing/GastonComoTrabajamos";
import ChiappellaComponentes from "@/components/landing/ChiappellaComponentes";
import ChiappellaProceso from "@/components/landing/ChiappellaProceso";
import ChiappellaGantt from "@/components/landing/ChiappellaGantt";
import ChiappellaResultados from "@/components/landing/ChiappellaResultados";
import ChiappellaInversion from "@/components/landing/ChiappellaInversion";
import GastonMapa from "@/components/landing/GastonMapa";
import GastonBeluxy from "@/components/landing/GastonBeluxy";
import ChiappellaGarantia from "@/components/landing/ChiappellaGarantia";
import ChiappellaCTA from "@/components/landing/ChiappellaCTA";
import AboutUs from "@/components/landing/AboutUs";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import PowerQuote from "@/components/landing/PowerQuote";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      {/* 01 — Hero */}
      <ChiappellaHero />
      {/* 02 — El Momento */}
      <Challenge />
      {/* 03 — La Jugada */}
      <ChiappellaVision />
      {/* 04 — Los tres frentes */}
      <GastonFrentes />
      {/* 05 — La credibilidad */}
      <GastonCredibilidad />
      {/* 06 — Cómo trabajamos (Ser · Hacer · Tener) */}
      <GastonComoTrabajamos />
      {/* 07 — La propuesta: dos rieles */}
      <ChiappellaComponentes />
      {/* 08 — El proceso */}
      <ChiappellaProceso />
      {/* 08b — Cronograma Gantt */}
      <ChiappellaGantt />
      {/* 09 — Resultados / entregables */}
      <ChiappellaResultados />
      {/* 10 — El equipo / liderazgo */}
      <Stats />
      <AboutUs />
      {/* Testimonios */}
      <Testimonials />
      {/* Pull-quote */}
      <PowerQuote />
      {/* 11 — Inversión */}
      <ChiappellaInversion />
      {/* 12 — El mapa completo */}
      <GastonMapa />
      {/* 13 — Club Beluxy */}
      <GastonBeluxy />
      {/* Garantía Coressen */}
      <ChiappellaGarantia />
      {/* 14 — CTA Final */}
      <ChiappellaCTA />
      {/* Footer */}
      <Footer />
    </main>
  );
};

export default Index;
